const hostUrl = `wss://${window.location.hostname}`
//const hostUrl = `ws://localhost:5000`

const gameModes = ["Cooperation", "Competitive"];

const MAX_SCORES = 10;

export { hostUrl, gameModes, MAX_SCORES };